<div class="row align-items-start position-relative" *ngIf="!showOnboarding">
    <div class="header-section">
        <h2 class="section-title">Permissões</h2>

    </div>
    <div class="col-lg-6">
        <ng-container *ngIf="canView.permissions">
            <app-dashboard-permissions-permission></app-dashboard-permissions-permission>
            <app-spacer [bottom]="16"></app-spacer>
        </ng-container>
    </div>

    <div class="col-lg-6">
        <ng-container *ngIf="canView.groups">
            <app-dashboard-permissions-user-groups></app-dashboard-permissions-user-groups>
            <app-spacer [bottom]="16"></app-spacer>
        </ng-container>

        <!-- Card de Empresas comentado - pode ser reativado se necessário -->
        <!-- <ng-container *ngIf="canView.companies">
            <app-dashboard-permissions-companies></app-dashboard-permissions-companies>
            <app-spacer [bottom]="16"></app-spacer>
        </ng-container> -->
    </div>
</div>

<!-- Explicação passo a passo comentada - vai direto para a página principal -->
<!-- <ng-container *ngIf="showOnboarding">
    <app-dashboard-permissions-onboarding
        (onClick)="closeOnboarding()"></app-dashboard-permissions-onboarding>
</ng-container> -->